import { render, staticRenderFns } from "./DiseasesCreate.vue?vue&type=template&id=2489f9da&scoped=true"
import script from "./DiseasesCreate.vue?vue&type=script&lang=js"
export * from "./DiseasesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489f9da",
  null
  
)

export default component.exports